import { useMemo } from 'react';
import { useGetParams } from './useGetParams';
import { testWords } from 'testWords';

export const useWordCloud = ({ idVote, voteState, currentState }) => {
  const { demo, minFontWords, maxFontWords } = useGetParams();

  const options = useMemo(() => {
    return {
      colors: [
        '#C50139',
        '#E639FF',
        '#0FB8C8',
        '#0092FF',
        '#ffffff',
        '#C20038',
      ],
      enableTooltip: false,
      deterministic: true,
      // fontFamily: 'mont',
      fontSizes: [minFontWords, maxFontWords],
      fontStyle: 'normal',
      fontWeight: 'bold',
      padding: 8,
      rotations: 3,
      rotationAngles: [0, 0],
      scale: 'sqrt',
      spiral: 'rectangular',
      transitionDuration: 500,
    };
  }, [minFontWords, maxFontWords]);

  const wordsNew = useMemo(() => {
    const res = {};
    voteState?.vars?.forEach((item, index) => {
      const word = item.comment?.trim();
      if (res[word]) {
        res[word].value = Number(item.count);
      } else {
        res[word] = {
          key: index,
          value: Number(item.count),
        };
      }
    });
    return Object.entries(res)
      .map((val) => ({
        text: val[0],
        value: val[1].value,
        key: val[1].key,
      }))
      .sort((a, b) => a.key - b.key)
      .filter((variant) => variant?.value !== 0);
  }, [voteState]);

  const countVote = useMemo(() => {
    return wordsNew?.reduce((acc, el) => acc + el?.value, 0) || 0;
  }, [wordsNew]);

  const wordsInTitre = useMemo(() => {
    return demo ? testWords : wordsNew;
  }, [countVote, demo, currentState, idVote]);

  const winWord = useMemo(() => {
    return wordsInTitre.reduce(
      (max, obj) => (obj.value > max.value ? obj : max),
      wordsInTitre[0],
    );
  }, [wordsInTitre]);

  return {
    options,
    winWord,
    wordsInTitre,
  };
};
